<template>
	<JBox class="s-p-8 s-mx-auto s-max-w-xl">
		<JHeadline class="s-text-4xl s-text-gray-700  s-font-base s-text-center">Create New App</JHeadline>
		<JText class="s-mb-12 s-text-center s-text-lg s-text-gray-500"
			>You can create client portals, distribution websites, admin consoles and more.</JText
		>

		<JFlex>
			<JBox class="s-w-1/2 s-pr-2">
				<CFormInput
					componentName="JInputText"
					name="name"
					label="Name your app"
					v-model="newApp.appName"
					class="s-mb-6"
					@input="generateAppIdFromName"
					@blur="$v.newApp.appName.$touch()"
				>
					<JText slot="bottom" class="s-text-red-500 s-text-xs" v-if="$v.newApp.appName.$error">This field is required</JText>
				</CFormInput>
			</JBox>
			<JBox class="s-w-1/2 s-pl-2">
				<CFormInput
					componentName="JInputText"
					name="appId"
					@blur="
						newApp.appId = makeCamelCase(newApp.appId)
						$v.newApp.appId.$touch()
					"
					label="App ID"
					v-model="newApp.appId"
					class="s-mb-6"
				>
					<JText slot="bottom" class="s-text-red-500 s-text-xs" v-if="$v.newApp.appId.$error">This field is required</JText>
				</CFormInput>
			</JBox>
		</JFlex>

		<!-- <CFormInput
			name="appTemplates"
			type="JRadios"
			label="Select app template"
			:options="appTemplates"
			v-model="newApp.appTemplateId"
			class="s-mb-6"
		/> -->

		<JFlex>
			<JBox class="s-w-1/2 s-pr-2">
				<CFormInput
					:componentName="injections.HostPicker"
					name="domain"
					label="Domain"
					v-model="newApp.host"
					@blur="$v.newApp.host.$touch()"
				>
					<JText slot="bottom" class="s-text-red-500 s-text-xs" v-if="$v.newApp.host.$error">This field is required</JText>
				</CFormInput>
				<JButton variant="default-light-xs" @click="showCreateHost = !showCreateHost">+ Add new domain</JButton>
			</JBox>
			<JBox class="s-w-1/2 s-pl-2">
				<CFormInput componentName="JInputText" name="url" label="Route Regex Pattern" v-model="newApp.regex" class="s-mb-6" />
			</JBox>
		</JFlex>

		<!-- App template -->
		<!-- <JBox class="s-mt-8">
			<AppTemplatePicker />
		</JBox> -->

		<!-- Buttons -->
		<JFlex class="s-justify-center s-items-center s-mt-10"
			><JButton variant="default-xl" @click="createApp">Create</JButton>
			<JSpinner class="s-ml-2" type="dots" v-if="isCreateAppLoading"
		/></JFlex>
		<JBox v-if="createAppError" class="s-text-center s-mt-4 s-text-red-600">
			{{ createAppError }}
		</JBox>

		<!-- Create Host -->
		<Portal to="layer1">
			<CModal :isVisible="showCreateHost" variant="default-small">
				<JBox class="s-p-8">
					<HostCreator @cancel="showCreateHost = false" @created="showCreateHost = false" />
				</JBox>
			</CModal>
		</Portal>
	</JBox>
</template>

<script>
import camelCase from "lodash.camelcase"
import HostPicker from "./HostPicker"
import HostCreator from "./HostCreator"
// import AppTemplatePicker from "./AppTemplatePicker"
import { required } from "vuelidate/lib/validators"

export default {
	components: { HostCreator },
	validations: {
		newApp: {
			appId: { required },
			appName: { required },
			host: { required }
		}
	},
	data() {
		return {
			isCreateAppLoading: false,
			createAppError: "",

			// Form for creation
			newApp: {
				appTemplateId: "blank",
				appId: null,
				appName: null,
				host: null,
				regex: null
			},

			// HACK: just mocking some posibilities
			appTemplates: [
				{ name: "Blank", value: "blank" },
				{ name: "Admin Portal", value: "admin_portal" },
				{ name: "Client Portal", value: "client_portal" },
				{ name: "Distribution Website", value: "distribution_website" }
			],

			// Create host
			showCreateHost: false,

			injections: {
				HostPicker
			}
		}
	},
	methods: {
		async createApp() {
			if (this.isCreateAppLoading) return // prevent multiple submit
			this.createAppError = "" // reset

			// Validate form
			this.$v.$touch()
			if (this.$v.$invalid) return

			this.isCreateAppLoading = true
			const { isSuccess } = await this.$store.dispatch("apps/createApp", { ...this.newApp })
			this.isCreateAppLoading = false

			if (!isSuccess) {
				this.createAppError = "Oops, there was an error when creating your app. Please try again." // TODO: localize
				return
			}

			this.$emit("created", { appId: this.newApp.appId })
		},

		generateAppIdFromName() {
			this.newApp.appId = this.makeCamelCase(this.newApp.appName)
		},

		makeCamelCase(value) {
			return camelCase(value)
		}
	}
}
</script>
